import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useWindowWith from "hooks/useWindowWidth";

function CarruselDos({ children }) {
  const [clicked, setClicked] = useState(false);
  const ancho = useWindowWith();

  const handleMouseDown = () => {
    setClicked(true);
  };
  const handleMouseUp = () => {
    setClicked(false);
  };

  const getSlides = () => {
    if (ancho >= 1366) return 4;
    if (ancho >= 1024) return 3;
    if (ancho >= 768) return 3;
    if (ancho >= 500) return 2;
    return 1;
  };

  var settings = {
    autoplay: false,
    dots: true,
    infinite: false,
    speed: 500,
    accessibility: true,
    pauseOnFocus: true,
    pauseOnHover: true,
    focusOnSelect: false,
    slidesToShow: getSlides(),
    slidesToScroll: getSlides(),
    initialSlide: 0,
    afterChange: () => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    },
  };
  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      className={`w-full overflow-hidden ${clicked ? "cursor-grabbing" : "cursor-grab"} pb-5`}
    >
      <Slider {...settings}>
        {children.map((item, index) => {
          return (
            <div key={index} className="p-4 pb-4" tabIndex={-1}>
              {item}
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default CarruselDos;
